import React, { HTMLAttributes } from 'react';
import request from '../lib/request';
import { useAsync } from 'eastedu-kit';
import { css, cx } from 'emotion';

const styles = {
  wrapper: css`
    position: relative;
    height: 100%;
    width: 100%;
  `,
  iframe: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  `,
  fullscreen_mask: css`
    position: absolute;
    right: 6px;
    background-color: #fff;
    width: 36px;
    height: 20px;
    z-index: 10;
    bottom: 1px;

    &.ppt,
    &.pptx {
      background-color: #444;
    }
  `,
};

interface OfficeViewerProps {
  viewType?: 'embed' | 'normal';
  url: string;
  iframeProps?: HTMLAttributes<HTMLDivElement>;

  style?: React.CSSProperties;
  className?: string;
  /** 传递扩展名将开启全屏按钮屏蔽 */
  extension?: string;
}

function OfficeViewer(props: OfficeViewerProps) {
  const { viewType = 'embed', url, style, className, iframeProps, extension } = props;

  const {
    result: previewUrl,
    loading,
    error,
  } = useAsync(async () => {
    if (/office\.eastedu\.com/.test(url)) {
      return url;
    }
    const urlMap = {
      embed: 'https://wopi.eastedu.com/api/wopi/link/embed-view',
      normal: 'https://wopi.eastedu.com/api/wopi/link/view',
    };

    const res = await request(`${urlMap[viewType]}/${encodeURIComponent(url)}`);
    return res.data;
  }, [viewType, url]);

  return (() => {
    if (!previewUrl || loading) {
      return null;
    }
    if (error) {
      return (
        <span
          style={{
            color: 'red',
          }}
        >
          预览出错，请稍后重试。
        </span>
      );
    }
    return (
      <div className={cx(styles.wrapper, className)} style={style}>
        <iframe src={previewUrl} className={styles.iframe} {...iframeProps} />
        {extension && <div className={cx(styles.fullscreen_mask, extension)} />}
      </div>
    );
  })();
}

export default OfficeViewer;
